import { render } from "./Bus.vue?vue&type=template&id=1197272c&ts=true"
import script from "./Bus.vue?vue&type=script&lang=ts"
export * from "./Bus.vue?vue&type=script&lang=ts"

import "./Bus.vue?vue&type=style&index=0&id=1197272c&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__